<template>
	<v-badge small color="orange" :value="canShowBadge">
		<template v-slot:badge>
			<span>
				<v-icon small>mdi-exclamation</v-icon>
			</span>
		</template>
		<v-icon>mdi-video</v-icon>
	</v-badge>
</template>

<script>
export default {
	inject: ['lessonPlanController'],
	computed: {
		hasVideoNotes() {
			return this.lessonPlanController.navigation.selectedSlide.notes.video;
		},
		canShowBadge() {
			return this.hasVideoNotes;
		}
	}
};
</script>
